import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {SurveyResponse} from 'main/stores/surveys';

class ResponseContainerState {
  store = new DomainStore();
  match;

  response;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({match}) {
    this.match = match;
  }

  async load() {
    const {id: surveyId, employeeId} = this.match.params;

    await this.store._compose([
      endpoints.SURVEYS.RESPONSE.withEmployeeId(surveyId, employeeId)
    ]);

    this.response = new SurveyResponse(
      this.store._getSingle(types.SURVEYS.RESPONSE)
    );
  }

  get backPath() {
    const {id: surveyId, backPath, employeeId} = this.match.params;

    if (backPath === 'employee') {
      return `/employees/${employeeId}/surveys`;
    } else {
      return `/surveys/manage/survey/${surveyId}/admin`;
    }
  }
}

export default ResponseContainerState;
